import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import TopIcon from "./TopIcon";


const Base = ({children}) => {
  return (
    <>
      <Navbar />
      <TopIcon/>
      {children}
      <Footer />
    </>
  );
};
export default Base;
